import { useEffect, useState } from "react";
import {
  Button,
  DialogTrigger,
  Heading,
  Input,
  Label,
} from "react-aria-components";

import { Modal } from "../../modal";

interface LinkModalProps {
  onInsertLink: (url: string) => void;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  currentUrl?: string | null;
}

export function LinkModal({
  onInsertLink,
  isOpen,
  onOpenChange,
  currentUrl,
}: LinkModalProps) {
  const [url, setUrl] = useState(currentUrl || "");

  // Reset URL when modal opens
  useEffect(() => {
    if (isOpen) {
      setUrl(currentUrl || "");
    }
  }, [isOpen, currentUrl]);

  const handleSubmit = () => {
    if (url.trim()) {
      onInsertLink(url.trim());
      setUrl("");
      onOpenChange(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleCancel = () => {
    setUrl("");
    onOpenChange(false);
  };

  const modalTitle = currentUrl ? "Edit Link" : "Insert Link";
  const submitButtonText = currentUrl ? "Update" : "Insert";

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange} size="md">
      <div className="p-6">
        <Heading className="mb-4 text-lg font-semibold" slot="title">
          {modalTitle}
        </Heading>
        <div className="space-y-4">
          <div className="flex flex-col gap-2">
            <Label className="text-sm font-medium">URL</Label>
            <Input
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="https://example.com"
              autoFocus
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button
              onPress={handleCancel}
              className="rounded-md bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
            >
              Cancel
            </Button>
            <Button
              onPress={handleSubmit}
              isDisabled={!url.trim()}
              className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed disabled:bg-gray-400"
            >
              {submitButtonText}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
